export default {
  name: 'UserListExpand',
  props: {
    data: Object
  },
  computed: {
    tableHeaders () {
      return [
        { key: 'name', label: this.$t('client.name'), type: 'routelink', routeTo: 'menu.client.edit', params: { clientApiId: 'api_id' } },
        { key: 'pivot.jobPosition', label: this.$t('user.jobPosition') },
        { key: 'pivot.canFillReports', label: this.$t('user.pivot.canFillReports'), format: 'formatYesNo' },
        { key: 'pivot.isContactPerson', label: this.$t('user.pivot.isContactPerson'), format: 'formatYesNo' },
        { key: 'pivot.isResponsiblePerson', label: this.$t('user.pivot.isResponsiblePerson'), format: 'formatYesNo' },
        { key: 'pivot.receiveBill', label: this.$t('user.pivot.receiveBill'), format: 'formatYesNo' },
        { key: 'pivot.receiveNotifications', label: this.$t('user.pivot.receiveNotifications'), format: 'formatYesNo' }
      ];
    }
  }
}
